const initPageOverlays = () => {
    const pageOverlays = document.querySelectorAll('.page-overlay')

    pageOverlays.forEach((pageOverlay) => {
        pageOverlay.addEventListener('click', () => {
            pageOverlay.classList.remove('open')

            if (pageOverlay.classList.contains('page-overlay-sidecart')) {
                document.querySelector('side-cart').classList.remove('open')
            }

            if (pageOverlay.classList.contains('page-overlay-productfilters')) {
                document.querySelector('product-filters').classList.remove('open')
            }

            if (pageOverlay.classList.contains('page-overlay-sizeguide')) {
                document.querySelector('size-guide.open').classList.remove('open')
            }
        })
    })
}

export { initPageOverlays }